import React, { ReactNode, ComponentProps } from 'react';

import PropTypes from 'prop-types';

import { RenderIconType } from '@adsk/alloy-react-icon';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

import TabTitle from './TabTitle';

/* These prop are applied by Tabs */

type TabProps = StylableComponent<HTMLDivElement> & {
  tab: string;
  label?: ReactNode;
  renderIcon?: RenderIconType;
  disabled?: boolean;
  labelProps?: ComponentProps<typeof TabTitle>;
};

const Tab = React.forwardRef<HTMLDivElement, TabProps>(
  ({ style, label, labelProps, className, children, ...props }, ref) => (
    <div {...props} className={className} css={[style]} ref={ref}>
      {children}
    </div>
  ),
);

Tab.displayName = 'Tab';

Tab.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /**  Tab content. Would be visible only when tab is active */
  children: PropTypes.any,
  /**  Tab title */
  label: PropTypes.any,
  /** Icon type */
  renderIcon: PropTypes.func,
  /**  Tab id used for tab selection (has to be unique) */
  tab: PropTypes.string.isRequired,
  /**  onClick event triggered on click tab */
  onClick: PropTypes.func,
  /** Props to pass to label component */
  labelProps: PropTypes.object,
};

export default Tab;
